import React from 'react'
import Contact from './Contact'
import Footer from './Footer'
import Hero from './Hero'
import Navbar from './Navbar'
import Pricing from './Pricing'
import Testimonial from './Testimonial'

const Home = () => {
    return (
        <>
            <Navbar/>
            <Hero/>
            <Pricing/>
            <Testimonial/>
            <Contact/>
            <Footer/>
            
            
        </>
    )
}

export default Home;
